export default {"src":"/_next/static/media/Chrome-mobile.33d59c6d.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};